import React from "react";
import { View } from "react-native";
import CustomButton from "../../components/button";
import InnerBoxTitle from "../../components/inner-box-title";
import InnerBox from "../../components/inner-box";
import Wrapper from "../../components/wrapper";
import translations from '../../utils/translations.json';
import { TranslateText } from "../../components/translate-text";

const WelcomePage = ({ setIndex }) => {
  return (
    <Wrapper>
      <TranslateText
        style={{
          fontSize: 28,
          marginVertical: 8,
          position: "absolute",
          top: 60,
        }}
      >
        Hollo DigiACT
      </TranslateText>
      <InnerBox>
        <View
          style={{
            height: "90%",
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <InnerBoxTitle
            title={translations["Welcome to the DigiACT Trial"]}
            subtitle={
              translations["You will be delivered a series of videos every two days, please remember to check in and complete your tasks!"]
            }
          />
        </View>
        <CustomButton
          title={translations["Next"]}
          onPress={() => {
            setIndex(3);
          }}
        />
      </InnerBox>
    </Wrapper>
  );
};

export default WelcomePage;
